/**
 * @file ForceMountPopover.tsx
 *
 * Temporary workaround for Popover component that requires forceMount prop.
 */
import { pdsTv } from '@purinanbm/pds-ui';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import React from 'react';

const content = /* #__PURE__*/ pdsTv({
  base: [
    'pds-max-w-[400px] pds-select-none pds-rounded pds-bg-surface pds-px-5 pds-py-4 pds-text-body-md pds-shadow-weak pds-outline-none',
  ],
  slots: {
    arrow: 'pds-fill-surface',
  },
  variants: {
    isOpen: {
      false: {
        base: 'pds-pointer-events-none pds-hidden',
      },
    },
    background: {
      dark: {
        base: 'pds-bg-surface-text pds-text-surface',
        arrow: 'pds-fill-surface-text',
      },
      light: {
        base: 'pds-bg-surface pds-text-surface-text',
        arrow: 'pds-fill-surface',
      },
    },
  },
});

interface IPopover extends PopoverPrimitive.PopoverContentProps {
  background?: 'dark' | 'light';
  isOpen?: boolean;
}

export const PopoverContent = React.forwardRef<HTMLDivElement, IPopover>(
  ({ children, isOpen, className, background = 'dark', ...props }, forwardedRef) => {
    const { base, arrow } = content({ background });
    return (
      <PopoverPrimitive.Portal forceMount>
        <PopoverPrimitive.Content
          className={base({ isOpen, className })}
          sideOffset={5}
          {...props}
          ref={forwardedRef}
        >
          <PopoverPrimitive.Arrow className={arrow({ className })} width={16} height={8} />
          {children}
        </PopoverPrimitive.Content>
      </PopoverPrimitive.Portal>
    );
  },
);
